/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeAddFulfillmentMethodRequest, serializeDeleteFulfillmentMethodRequest, serializeOk, type AddFulfillmentMethodRequest, type DeleteFulfillmentMethodRequest, type ErrorResponse, type Ok } from '../../../models/index.js';
// @ts-ignore
import { ReorderRequestBuilderRequestsMetadata, type ReorderRequestBuilder } from './reorder/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/fulfillment-methods
 */
export interface FulfillmentMethodsRequestBuilder extends BaseRequestBuilder<FulfillmentMethodsRequestBuilder> {
    /**
     * The reorder property
     */
    get reorder(): ReorderRequestBuilder;
    /**
     * Removes a fulfillment method from the organization's list. Carts and orders already carrying the value keep it — this only curates the picker options.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     delete(body: DeleteFulfillmentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Adds a fulfillment method (e.g. Ship, Pickup, Delivery) to the organization's list, which reps pick from on a cart. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     */
     post(body: AddFulfillmentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Removes a fulfillment method from the organization's list. Carts and orders already carrying the value keep it — this only curates the picker options.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteFulfillmentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds a fulfillment method (e.g. Ship, Pickup, Delivery) to the organization's list, which reps pick from on a cart. The domain trims the value, dedupes case-insensitively, and keeps the casing first typed; a blank value is ignored.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AddFulfillmentMethodRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FulfillmentMethodsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/fulfillment-methods";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FulfillmentMethodsRequestBuilderNavigationMetadata: Record<Exclude<keyof FulfillmentMethodsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    reorder: {
        requestsMetadata: ReorderRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FulfillmentMethodsRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: FulfillmentMethodsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteFulfillmentMethodRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    post: {
        uriTemplate: FulfillmentMethodsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAddFulfillmentMethodRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
